import React, { Fragment } from 'react';
import { StyledTabButton, StyledTabButtonContainer, Title } from './tabButton.style';

const TabButton = (props) => {
  const { buttonArray, onButtonClick = () => {}, selectedTab } = props;

  const handleClickedTabButton = (item) => {
    if (item) {
      onButtonClick(item.buttonText);
    }
  };
  return (
    <StyledTabButtonContainer>
      {buttonArray?.map((item, index) => {
        return (
          <Fragment key={index}>
            <StyledTabButton
              isFirst={index === 0}
              isLast={index === buttonArray?.length - 1}
              isMiddle={index !== 0 && index !== buttonArray?.length - 1}
              textTransform="capitalize"
              onClick={() => handleClickedTabButton(item)}
              isActive={selectedTab === item.buttonText}
            >
              {item.icon}
              <Title
                align="center"
                cursor="pointer"
                color="primary"
                isActive={selectedTab === item.buttonText}
              >
                {item.buttonText}
              </Title>
            </StyledTabButton>
          </Fragment>
        );
      })}
    </StyledTabButtonContainer>
  );
};

export default TabButton;
